module.exports = __webpack_public_path__ + "static/media/icon-nav-heart-filled.0ae03c3c.svg";